import { Performer } from '../core/performer'
import { HttpMethod } from '../core/types'

export class AddIncomeImg extends Performer<
  {
    payload: FormData
    urlParams: {
      incomeId: number
    }
  },
  void
> {
  protected method = HttpMethod.POST
  protected url = '/incomes/{incomeId}/image'
}

export default new AddIncomeImg().perform
